import { useEffect, useRef } from 'react';
import { isEmpty } from 'lodash';

export const usePreviousNotEmptyArray = (value) => {
    const ref = useRef([]);
    useEffect(() => {
        if (!isEmpty(value)) {
            ref.current = value;
        }
    }, [value]);
    return ref.current;
};
